import { initialState } from "../initialState/initialState";

const blogsReducer = (state = initialState, action) => {
    switch (action.type) {
        case "GETALLBLOGS":
            return state;

        default:
            return state;
    }
};

export default blogsReducer;
